"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceStatus = exports.InvoicePaymentStatus = void 0;
var InvoicePaymentStatus;
(function (InvoicePaymentStatus) {
    InvoicePaymentStatus["OVERDUE"] = "Overdue";
    InvoicePaymentStatus["PAID"] = "Paid";
    InvoicePaymentStatus["PARTIALLY_PAID"] = "Partially Paid";
    InvoicePaymentStatus["UNPAID"] = "Unpaid";
})(InvoicePaymentStatus = exports.InvoicePaymentStatus || (exports.InvoicePaymentStatus = {}));
var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["DRAFT"] = "Draft";
    InvoiceStatus["CANCELLED"] = "Cancelled";
    InvoiceStatus["ERROR"] = "Error";
    InvoiceStatus["INITIATED"] = "Initiated";
    InvoiceStatus["POSTED"] = "Posted";
    InvoiceStatus["POST_IN_PROGRESS"] = "Post In Progress";
    InvoiceStatus["REBILLED"] = "Rebilled";
    InvoiceStatus["CREDITED"] = "Credited";
})(InvoiceStatus = exports.InvoiceStatus || (exports.InvoiceStatus = {}));
